import React from 'react'
import { Dialog } from '@mui/material';

const Modal = ({ open, setOpen, children, width = '70vw' }) => {
    return (
        <Dialog
            fullWidth
            maxWidth="lg"
            open={open}
            onClose={() => setOpen(false)}
            PaperProps={{
                style: {
                    width,
                    maxWidth: '95vw',
                }
            }}
        >
            {children}
        </Dialog>
    )
}

export default Modal